<lla-selector-card
  label="Select Locations"
  [value]="selectedShopsLabel"
  icon="garage"
  [capitalizeLabel]="true"
  (click)="shopSelectorMenuTrigger.openMenu()"
  [llaTippy]="selectedIds.length > 1 ? shopListTooltipTemplate : undefined"
  [llaTippyProps]="tooltipOption"
></lla-selector-card>
<div
  (menuClosed)="resetSelection()"
  [matMenuTriggerFor]="shopSelectorMenu"
  #shopSelectorMenuTrigger="matMenuTrigger"
></div>

<mat-menu #shopSelectorMenu="matMenu" [hasBackdrop]="true" class="lla-filter-menu">
  <div (click)="$event.stopPropagation()" class="flex flex-col relative" style="max-height: 80dvh">
    <div class="flex justify-end p-base text-sm leading-sm text-txt">
      You can select up to {{ maxSelectableShops }} locations.
    </div>
    <form [formGroup]="form" class="px-base flex-1 overflow-y-auto flex flex-col beautyScroll">
      <lla-shops-selector
        [selectedGroups]="selectedShopGroups"
        controlName="locationIds"
        [hideStates]="true"
        [minSelectable]="1"
        [maxSelectable]="maxSelectableShops"
        [onlyUserShops]="onlyUserShops"
      ></lla-shops-selector>
    </form>
    <div class="mx-base py-sm flex items-center justify-end">
      <lla-button
        size="medium"
        [disabled]="form.invalid"
        (click)="
          selectedIdsChanged.emit(form.value?.locationIds ?? []); shopSelectorMenuTrigger.closeMenu()
        "
      >
        Show results
        {{ this.form.value?.locationIds?.length ? '(' + this.form.value.locationIds.length + ')' : '' }}
      </lla-button>
    </div>
  </div>
</mat-menu>

<ng-template #shopListTooltipTemplate>
  <div class="flex flex-col gap-xs w-full md:min-w-[228px]">
    @for (item of getSelectedShopNames(); track item) {
      <div class="text-sm leading-sm text-txt">
        {{ item }}
      </div>
    }
  </div>
</ng-template>
